<header class="landing-header" [style.background-color]="config.header?.background_color">
  <img *ngIf="config.header?.image" [src]="config.header.image" alt="logo" />
</header>

<section
  class="landing-hero"
  [style.background-image]="config.body?.image ? 'url(' + config.body.image + ')' : null"
>
  <div class="landing-hero-content" [style.color]="config.header?.text_color">
    <h1>{{ config.header?.title }}</h1>
    <p *ngIf="config.body?.intructions">{{ config.body.intructions }}</p>
  </div>
</section>
